<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-06 15:57:18
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-29 18:32:14
 * @FilePath: /jy-dashboard-web/src/components/productionManagement/cyjkts/chart-line.vue
 * @Description: 玫瑰图
-->
<template>
  <div id="chart-line" v-loading="loading.zbqs"></div>
</template>

<script>
import { Chart } from '@antv/g2'
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      chart: null
    }
  },
  computed: {
    ...mapState('production-management', ['zbqs', 'zblx', 'loading'])
  },
  watch: {
    'zblx' (newValue) {
      this.getZBQS(newValue)
    },
    'zbqs' (newValue) {
      if (this.chart) {
        this.chart.changeData(newValue)
      } else {
        this.initChart()
      }
    }
  },
  methods: {
    ...mapActions('production-management', ['getZBQS']),
    initChart () {
      this.chart = new Chart({
        container: 'chart-line',
        autoFit: true
      })
      this.chart.data(this.zbqs)
      this.chart.legend(false)
      this.chart.tooltip(false)
      this.chart.scale('zssz', {
        min: 0, max: 5, alias: '指数'
      })
      this.chart.axis('zssz', {
        position: 'left',
        tickCount: 5,
        label: {
          style: {
            fill: '#FFFFFF'
          }
        },
        grid: {
          line: {
            style: {
              stroke: '#d9d9d9',
              lineWidth: 1,
              lineDash: [1, 1]
            }
          }
        }
      })
      this.chart.scale('zssj', {
        formatter: (v, k) => {
          const date = new Date(v)
          return (date.getMonth() + 1) + '-' + date.getDate()
        }
      })
      this.chart.axis('zssj', {
        position: 'bottom',
        label: {
          style: {
            fill: '#FFFFFF'
          }
        }
      })
      this.chart
        .area()
        .position('zssj*zssz')
        .color('l(270) 0:#000000 1:#38f7ff')
      this.chart
        .line()
        .position('zssj*zssz')
        .label('zssz', {
          offset: 8,
          style: {
            fill: '#ffffff'
          }
        })
        .shape('smooth')
        .color('#38f7ff')
      this.chart.render()
    }
  },
  mounted () {
    this.getZBQS(this.zblx)
  }
}
</script>
